export const blockIconsContentUndo = (
	<span className='material-symbols-outlined'>undo</span>
);
